import { useState, useEffect } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

import Login from './Login/Login'
import { fetchUserProfile } from './AccountUtils'
import { ImpersonateUser } from './ImpersonateUser/ImpersonateUser'
import { useSession } from 'hooks/useSession'
import { SuperAdmin } from './SuperAdmin/SuperAdmin'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Spinner } from 'common/Spinner/Spinner'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Modal } from 'almanac-ui/Modal'

const initialState = {
  email_visible: false,
  email: '',
}

export const Account = () => {
  const location = useLocation<{ passwordChanged?: boolean }>()
  const currentWorkspace = useCurrentWorkspace()
  const { isMobile } = useResponsiveDesign()
  const [isLoading, setLoading] = useState(false)
  const [profileInformation, setProfileInformation] = useState(initialState)
  const { auth } = useSession()
  const isSettingsModalUpdateEnabled = useFlipperFlag('settings_modal_update')

  useEffect(() => {
    setLoading(true)
    if (!auth) return

    if (location?.state?.passwordChanged) showToastMessage('Password successfully changed 🎉', 'success')
    fetchUserProfile(auth.id, setProfileInformation)
    setLoading(false)
  }, [auth, location])

  if (isLoading || !profileInformation.email) return <Spinner className={SettingsStyles.spinner} />

  return (
    <>
      {!isMobile && !isSettingsModalUpdateEnabled && (
        <header className={SettingsStyles.subHeader}>
          <Heading level={3} data-test-id="my-account-title">
            Account
          </Heading>
        </header>
      )}
      {isSettingsModalUpdateEnabled && <Modal.Header title="Account" className={SettingsStyles.newHeader} />}
      <Login profileInformation={profileInformation} setProfileInformation={setProfileInformation} />
      {currentWorkspace?.super_admin && <SuperAdmin />}
      <ImpersonateUser />
    </>
  )
}

export default withRouter(Account)
